import React from 'react';
import Input, { InputAdornment } from 'material-ui/Input';
import { FormControl, FormHelperText } from 'material-ui/Form';
import './Input.css'

function PrcInput (props) {
        return (
                <FormControl className={props.className} >
                    <label className="sr-only" htmlFor={props.id}>{props.label}</label>
                    <Input
                        {...props.InputProps}
                        className={"prcInput__inputTag" + (props.InputProps.disabled? " disabled--input" : '')}
                        startAdornment={
                            props.adornment?
                            <InputAdornment position="start">
                                {props.adornment}
                            </InputAdornment> : ''}
                        id={props.id}
                    />
                    {props.InputProps.error?
                        <FormHelperText className="prcInput__helpText">{props.helpText}</FormHelperText> : ''}
                </FormControl>
        )
}

export default PrcInput;
